import {Component, OnInit} from '@angular/core';
import {FileUploadEvent, FileUploadModule} from "primeng/fileupload";
import {CommonModule} from "@angular/common";
import {MenuItem, MessageService, PrimeNGConfig} from "primeng/api";
import {StepsModule} from "primeng/steps";
import {ToastModule} from "primeng/toast";
import {CardModule} from "primeng/card";
import {SelectButtonModule} from "primeng/selectbutton";
import {FormArray, FormBuilder, Validators, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {InputSwitchModule} from "primeng/inputswitch";
import {FormElementComponent} from "../../shared/forms/form-element/form-element.component";
import {FormTypes} from "../../shared/forms/models/constants";
import {DragDropScrollComponent, SignPositionEvent} from "../document-viewer/drag-drop-scroll.component";
import {DialogService, DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {SelfSignUrlData, SipoService} from "../services/SipoService";
import {PdfDto} from "../model/pdf-dto";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {BadgeModule} from "primeng/badge";
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {CSCProviders, CscSignDocService} from "../services/CscSignDocService";
import {UploadDocumentComponent} from "./upload-document/upload-document.component";
import {SignerOptionsComponent} from "./signer-options/signer-options.component";
import {AddSignersComponent} from "./add-signers/add-signers.component";
import {an, b} from "@fullcalendar/core/internal-common";
import {SignatureLevel, SignerModel, SignPositions} from "../model/signer-model";
import {CommentsAndObserversComponent} from "./comments-and-observers/comments-and-observers.component";
import {FinalPreviewComponent} from "./final-preview/final-preview.component";
import {FileModel} from "../model/file-model";
import {SignProcessStateComponent} from "./sign-process-state/sign-process-state.component";
import {PdfSize} from "../model/position";
import {UserService} from "../../shared/services/user.service";
import {TriggerEventCommunicationService} from "../services/trigger-event-communication.service";
import {
    CancelSignConfirmationModalComponent
} from "./cancel-sign-confirmation-modal/cancel-sign-confirmation-modal.component";
import {BehaviorSubject, forkJoin, Observable, Subscription} from "rxjs";
import {UserPropertiesService} from "../services/user-properties.service";
import {SignProcessEditingService} from "../services/sign-process-editing.service";
import {SubscriptionsService} from "../services/subscriptions.service";
import {Subscriptions} from "../model/subscriptions.models";

import {of} from 'rxjs';
import {catchError} from 'rxjs/operators';

interface UploadEvent {
    originalEvent: Event;
    // files: File[];
}

@Component({
    selector: 'app-sign',
    standalone: true,
    imports: [
        CommonModule,
        FileUploadModule,
        StepsModule,
        ToastModule,
        CardModule,
        SelectButtonModule,
        ReactiveFormsModule,
        FormsModule,
        InputSwitchModule,
        DragDropScrollComponent,
        ProgressSpinnerModule,
        BadgeModule,
        TranslateModule,
        UploadDocumentComponent,
        AddSignersComponent,
        CommentsAndObserversComponent,
        FinalPreviewComponent,
        SignProcessStateComponent,
    ],
    providers: [MessageService],
    templateUrl: './sign.component.html',
    styleUrl: './sign.component.scss'
})
export class SignComponent implements OnInit {
    protected readonly FormTypes = FormTypes;

    signerEmailShared!: {
        index: number,
        email: string,
        fullName: string,
        isCreator: boolean
    }[]

    active: number = 0;
    screenWidth!: number;
    items: MenuItem[] | undefined;
    activeIndex: number = 0;
    activeIndexDescription!: string;
    files: File[] = [];
    formGroup: FormGroup = this.formBuilder.group({
        isPdfUploaded: [false],
        iamsigning: [false],
        legalweight: [],

        message: [''],
        observers: this.formBuilder.control<string[]>([]),
        signers: this.formBuilder.array([]),

        signingtype: ['']
    });

    isSelectedFileLoading: boolean = false;
    pdfFileUploadingProcessTrack!: 'success' | 'error' | 'progress';

    signProcessId: string = "";
    pdfId: string = "";

    signerModel: SignerModel = {
        signingProcessId: "",
        fileId: "",
        fileName: "",
        multipleSigners: false,
        signingType: "",
        iamsigning: false,
        signers: [],
        signpositions: [],
        observers: [],
        additionalFiles: [],
        message: "",
        draft: false
    };


    pdfDto: PdfDto = {
        fileName: "",
        id: "",
        images: [],
        width: 0,
        height: 0
    };
    pdfSize!: PdfSize;
    signOnlyMe: boolean = false;

    selfSignUrl: string = "";
    userSubscription!: Subscriptions;

    constructor(private formBuilder: FormBuilder,
                private ref: DynamicDialogRef,
                private sipoService: SipoService,
                private translateService: TranslateService,
                private userService: UserService,
                private triggerEventService: TriggerEventCommunicationService,
                private userPropertiesService: UserPropertiesService,
                private signProcessEditingService: SignProcessEditingService,
                public dialogService: DialogService,
                public config: DynamicDialogConfig,
                private subscriptionsService: SubscriptionsService
    ) {
    }

    loggedInUser: any;
    editingProcessId: string | null = null;

    ngOnInit() {

        this.editingProcessId = this.config.data.editingProcessId;


        // DON'T FORGET TO REMOVE THE loggedInUser VARIABLE AND THE USER SERVICE REQUEST WHEN THE BACKEND UPDATED
        this.userService.getLoggedInUser().subscribe(res => {
            this.loggedInUser = res;
        })
        //this.signerModel = this.sipoTestdataService.getRequestSignerModel();

        if (!this.formGroup.get('legalweight')?.value || this.formGroup.get('legalweight')?.value.length === 0) {
            this.userPropertiesService.getByKey('sipo.settings.evidence').pipe(
                catchError(() => of({userPropertyValue: SignatureLevel.BASIC}))
            ).subscribe(res => {
                const val = res.userPropertyValue?.length > 0 ? res.userPropertyValue : SignatureLevel.BASIC;
                this.formGroup.get('legalweight')?.setValue(val);
                this.signerModel.signingType = val;
            });
        }

        this.declareLabels();
        this.returnActiveIndexObj();
        this.getDisabledPropertyOfNextButton();
        this.isStepsDisabled();

        this.formGroup.valueChanges.subscribe(res => {
            this.isStepsDisabled();
        })

        this.processIdSubscription = this.signProcessEditingService.processIdBehaviorSubjectObservable$.subscribe(res => {
            if (res.length > 0) {
                this.processId = res
                this.getSignProcess();
                this.activeIndex = 1;
                this.isEditingProcess = true;
            }
        })

        this.subscriptionsService.getCurrentUsersSubscriptions().subscribe(res => {
            this.userSubscription = res;
        })
    }

    // these methods and variables are used to get the sign process data from backend if an already existing process is editing
    processId!: string;
    processIdSubscription!: Subscription;
    isEditingProcess: boolean = false;

    getExistingPositions() {

        let subItems = [];

        this.sipoService.getSubItemsList(this.processId).subscribe({
            next: value => {
                subItems = value;

                const positionRequests = subItems.map((subItem: any) =>
                    this.sipoService.getPositionsByItem(subItem.id)
                );

                forkJoin(positionRequests).subscribe({
                    next: (allPositions: any) => {
                        if (this.signerModel.signpositions) {
                            this.signerModel.signpositions = allPositions.map((positions: any) => positions[0]);
                        }

                        this.signerModel.signers.forEach((signer: any, index) => {
                            if (this.loggedInUser.email != signer.email) {
                                const newData = {
                                    index: index,
                                    fullName: signer.fullName,
                                    email: signer.email,
                                    isCreator: signer.isCreator,
                                }

                                this.signerEmailShared.push(newData)
                            }

                        })
                    },
                    error: err => {
                        console.error(err);
                    }
                });
            },
            error: err => {
                console.error(err)
            }
        })
    }

    getSignProcess() {
        this.sipoService.getSignerModel(this.processId).subscribe({
            next: (data: SignerModel) => {
                if (data) {
                    this.signerModel = data;

                    const signersArray = this.formGroup.get('signers') as FormArray;
                    signersArray.clear();

                    data.signers.forEach(s => {
                        if (this.loggedInUser.email != s.email) {
                            signersArray.push(this.formBuilder.group({
                                fullName: s.fullName,
                                email: s.email,
                                isCreator: s.isCreator,
                            }));
                        }
                    });

                    this.formGroup.patchValue({
                        isPdfUploaded: true,
                        iamsigning: data.iamsigning,
                        legalweight: data.signingType,
                        message: data.message,
                        observers: data.observers,
                        signingtype: data.signingType,
                    });

                    this.getExistingPositions();
                }
            },
            error: err => {
                console.log(err);
            }
        })
    }

    declareLabels() {
        this.screenWidth = window.innerWidth;

        if (this.screenWidth < 768) {
            this.items = [
                {
                    label: '',
                },
                {
                    label: '',
                },
                {
                    label: '',
                },
                {
                    label: '',
                },
                {
                    label: '',
                }
            ];
        } else {
            this.items = [
                {
                    label: this.returnLabelFromi18('upload-document'),
                },
                {
                    label: this.returnLabelFromi18('add-signer-signature-type'),
                },
                {
                    label: this.returnLabelFromi18('signature-positions'),
                },
                {
                    label: this.returnLabelFromi18('comments-and-observers'),
                },
                {
                    label: this.returnLabelFromi18('final'),
                }
            ];
        }
    }

    isStepsDisabled(isAllIdsPlaced?: boolean) {
        let i = 1;
        if (this.formGroup.get('isPdfUploaded')?.value) {
            i = 2
        }

        const isEmailEmpty = this.formGroup.value.signers?.some((signer: {
            fullName: string,
            email: string
        }) => signer.email.length === 0);
        if (this.formGroup.get('iamsigning')?.value || (this.formGroup.get('signers')?.value?.length > 0 && !isEmailEmpty)) {
            i = 3;
        }

        if (this.items) {
            this.items.forEach(item => {
                item.disabled = false;
            })

            if (this.isEditingProcess) {
                this.items[0].disabled = true;
            }

            if (!isAllIdsPlaced) {
                for (i; i < this.items?.length; i++) {
                    this.items[i].disabled = true;
                }
            }
            this.items = [...this.items];
        }

    }

    getDisabledPropertyOfNextButton(): boolean {
        let isDisabled: boolean = false;

        if (this.activeIndex === 0 && this.files.length <= 0) {

            isDisabled = true

        } else if (this.activeIndex === 1) {

            const isSignerSelected = (this.formGroup.value.iamsigning) || (this.formGroup.value.signers?.length > 0) ? true : false;

            const isLegalWeightSelected = this.formGroup.value.legalweight ? true : false;

            const isEmailEmpty = this.formGroup.value.signers?.some((signer: {
                fullName: string,
                email: string
            }) => signer.email.length === 0);

            isDisabled = !isSignerSelected || !isLegalWeightSelected || isEmailEmpty;
        } else if (this.activeIndex === 2 && !this.isAllIdCardsPlaced) {
            isDisabled = true;
        }

        return isDisabled
    }

    returnActiveIndexObj() {
        let key: string = `sipo.step-${this.activeIndex + 1}-explanation`;

        this.translateService.get(key).subscribe(data => this.activeIndexDescription = data)
    }

    onActiveIndexChange(event: number) {
        if (this.formGroup.value.signingtype === 'me' && event === 2) {
            this.formGroup.get('iamsigning')?.setValue(true);
        } else {
            this.activeIndex = event;
        }
        this.returnActiveIndexObj()
    }

    returnLabelFromi18(i18Value: string): string {
        let label = '';
        this.translateService.get(`sipo.${i18Value}`).subscribe(data => label = data);
        return label;
    }

    receiveSigners(signers: FormGroup | 'close'): void {

        if (signers != 'close') {
            const rawValue = signers.getRawValue();

            this.signerEmailShared = rawValue.signers;

            if (rawValue.iamsigning) {
                this.userService.getLoggedInUser().subscribe(user => {
                    this.signerEmailShared.push({
                        email: user.email,
                        fullName: `${user.firstname} ${user.lastname}`,
                        index: rawValue.signers?.length,
                        isCreator: true
                    });
                });

            }
            this.signerModel.iamsigning = rawValue.iamsigning;
            this.signerModel.signers = rawValue.signers;
            this.signerModel.signingType = rawValue.legalweight;

            this.signerModel.multipleSigners = this.signerModel.signers?.length > 0;

            this.getDisabledPropertyOfNextButton();
            this.isStepsDisabled();
        } else {
            this.deleteProcess();
            this.ref.close();
        }
    }

    toastInfo: { isOpen: boolean, state: string, isSelfSign: boolean } = {isOpen: false, state: '', isSelfSign: false}

    save(draft: boolean = false) {
        if (this.activeIndex === 4 || draft) {

            if (!draft) {
                this.toastInfo.isOpen = true;
            }

            if (this.signOnlyMe) {
                this.signerModel.iamsigning = this.signOnlyMe;
            }
            if (draft) {
                this.signerModel.draft = true;
            }
            this.signerModel.signpositions = this.normalizeYValues(this.signerModel.signpositions, 10);
            this.signerModel.signingType = this.signerModel.signingType.toLowerCase();
            if (this.isEditingProcess) {
                this.updateSignerModel()
            } else {
                this.postSignerModel()
            }

        } else {

            this.activeIndex++;
        }
        this.returnActiveIndexObj();
    }

    // this method is used to simplify post and update requests. The steps inside subscription are used in both requests so with this method we pretend code repetition.
    private handleSignerModelRequest(request$: Observable<SelfSignUrlData>) {
        request$.subscribe({
            next: (value) => {
                const data = typeof value === 'string' ? JSON.parse(value) : value as SelfSignUrlData;
                this.selfSignUrl = data.url ?? `/signing/${data.process}/${data.subItem}`;
                const selfSignFormValue = this.formGroup.value.iamsigning;

                this.toastInfo = {isOpen: true, state: 'success', isSelfSign: selfSignFormValue};
                this.triggerEventService.triggerEvent();

                if (!selfSignFormValue) {
                    setTimeout(() => {
                        this.toastInfo = {isOpen: false, state: '', isSelfSign: false};
                        this.closeSign(true);
                    }, 5000);
                }
            },
            error: (error: any) => {
                console.error(error);
                this.toastInfo = {isOpen: true, state: 'error', isSelfSign: false};
                setTimeout(() => {
                    this.toastInfo.isOpen = false;
                }, 5000);
            }
        });
    }

    postSignerModel() {
        this.handleSignerModelRequest(this.sipoService.postSignerModel(this.signerModel));
    }

    updateSignerModel() {

        if (this.editingProcessId === null) {
            alert(this.editingProcessId + "is null");
            return;
        }
        this.signerModel.signingProcessId = this.editingProcessId;
        this.handleSignerModelRequest(this.sipoService.updateSignerModel(this.signerModel));
    }

    deleteProcess() {
        if (this.signerModel.signingProcessId.length > 0) {
            this.sipoService.deleteProcess(this.signerModel.signingProcessId).subscribe({
                next: (value: any) => {
                    console.log('deleting process succeded')
                },
                error: (error: any) => {
                    console.error(error);
                }
            })
        }
    }


    // Datei über den Service hochladen
    async uploadPdf() {

        this.pdfFileUploadingProcessTrack = "progress"

        setTimeout(() => {
            this.isSelectedFileLoading = true;

            setTimeout(() => {
                this.isSelectedFileLoading = false;
            }, 1500);
        });

        if (this.files) {
            const uploadFile = this.files[0];
            await this.sipoService.uploadPdfPromise(uploadFile).then(value1 => {

                this.signerModel.signingProcessId = value1.signProcessId;
                this.signerModel.fileId = value1.signPdfId;
                this.signerModel.fileName = uploadFile.name;

                this.signProcessId = value1.signProcessId;
                this.pdfId = value1.signPdfId;

            }).catch(reason => {
                console.log(reason);
            });

            if (this.pdfId) {
                await this.sipoService.getImagesPromise(this.pdfId).then(value2 => {
                    this.pdfDto = value2;
                    this.pdfFileUploadingProcessTrack = 'success';
                }).catch(reason => {
                    this.pdfFileUploadingProcessTrack = 'error';
                    console.log(reason);
                });
            }

        } else {
            alert('Please select a file first.');
        }
    }

    // uploaded files
    receiveFiles(files: any) {
        this.files = files;
        this.formGroup.get('isPdfUploaded')?.setValue(true);
        this.uploadPdf();
        this.getDisabledPropertyOfNextButton();
        this.isStepsDisabled();
    }

    signLink: string | undefined = undefined;

    observerAndCommentsComponentFileArray: File[] = [];

    receiveAdditionalFiles(event: File[]) {
        this.observerAndCommentsComponentFileArray = event;
    }

    getObserverAndComments($event: { files: FileModel[], formGroup: FormGroup }) {

        const rawValue = $event.formGroup.getRawValue();
        const files = $event.files;

        this.signerModel.additionalFiles = files;
        this.signerModel.message = rawValue.message;
        this.signerModel.observers = rawValue.observers;
    }

    // The variable below "isCloseTriggered" is used to receive data from children components. Without this some data could be lost in signing task creation process
    isCloseTriggered: boolean = false;

    cancelSignComponentDialogRef!: DynamicDialogRef;

    closeSign(justClose: boolean) {

        if (!this.signerModel.pdfSize) {
            this.signerModel.pdfSize = {
                width: 0,
                height: 0,
            }
        }

        if (justClose || (this.toastInfo.isOpen && this.toastInfo.state === 'success' && this.activeIndex === 4)) {
            this.ref.close(this.signerModel.signingType);
        } else {

            this.cancelSignComponentDialogRef = this.dialogService.open(CancelSignConfirmationModalComponent, {
                width: '75rem',
                data: {signerModel: this.signerModel}
            });

            this.cancelSignComponentDialogRef.onClose.subscribe((closingStateObj) => {
                if (closingStateObj?.close) {
                    if (closingStateObj.saveAsDraft) {
                        this.save(true)
                        this.ref.close(this.signerModel.signingType);
                    } else {
                        this.deleteProcess();
                        this.ref.close();
                    }
                }
                this.isCloseTriggered = false;
            })
            this.isCloseTriggered = true;
        }
    }

    getPdfSize(pdfSize: PdfSize) {
        this.pdfSize = pdfSize;
        this.signerModel.pdfSize = pdfSize;
    }

    getSignPositions(positions: SignPositionEvent[]) {

        if (positions.length > 0) {
            this.signerModel.signpositions = [];

            positions.forEach((item) => {

                const signer = item.signer;
                item.positions?.forEach((p) => {
                    const pos: SignPositions = {
                        signer: signer,
                        x: p?.x || 0,
                        y: p?.y || 0,
                        pageNumber: p?.pageNumber || 0,
                        displayWidth: p?.displayWidth || 0,
                        displayHeight: p?.displayHeight || 0,
                        width: 0,
                        height: 0,
                    } as SignPositions;

                    this.signerModel.signpositions.push(pos);
                });

            });

            this.signerModel.signpositions = this.normalizeYValues(this.signerModel.signpositions, 10)
        }


    }

    // this boolean type variable and the receive event is used for to control all the signers positions placed or not in drag-and-drop component
    isAllIdCardsPlaced: boolean = false;

    receiveStepAvailability(event: boolean) {
        this.isAllIdCardsPlaced = event;
        this.isStepsDisabled(this.isAllIdCardsPlaced);
        this.getDisabledPropertyOfNextButton();
    }

    // The method below receives the loading info from drag and drop component and then the received data is used for control overflow Y axis scroll
    isYaxisScrollAvailable: boolean = true;

    receiveIsLoading(event: boolean) {
        this.isYaxisScrollAvailable = event;
    }


    normalizeYValues(objects: SignPositions[], tolerancePercent = 2): SignPositions[] {
        if (!Array.isArray(objects)) {
            console.warn('normalizeYValues: objects is not an array, defaulting to empty array', objects);
            objects = [];
        }

        const tolerance = tolerancePercent / 100;

        // Sortiere nach Y-Wert
        const sorted = [...objects].sort((a, b) => a.y - b.y);

        const groups: number[][] = [];
        let currentGroup: number[] = [];

        for (const obj of sorted) {
            if (currentGroup.length === 0) {
                currentGroup.push(obj.y);
            } else {
                const referenceY = currentGroup[0];
                const diffPercent = Math.abs(obj.y - referenceY) / referenceY;

                if (diffPercent <= tolerance) {
                    currentGroup.push(obj.y);
                } else {
                    groups.push(currentGroup);
                    currentGroup = [obj.y];
                }
            }
        }
        if (currentGroup.length > 0) {
            groups.push(currentGroup);
        }

        // Berechne Mittelwerte für jede Gruppe
        const groupMeans = groups.map(group => {
            const sum = group.reduce((acc, val) => acc + val, 0);
            return sum / group.length;
        });

        // Jetzt ersetzen
        const normalizedObjects = objects.map(obj => {
            for (const mean of groupMeans) {
                const diffPercent = Math.abs(obj.y - mean) / mean;
                if (diffPercent <= tolerance) {
                    return {...obj, y: mean};
                }
            }
            return obj;
        });

        return normalizedObjects;
    }

    ngOnDestroy() {
        this.signProcessEditingService.updateProcessId('');
        this.processIdSubscription.unsubscribe();
    }

}
